import type { components } from "@jbnl/api-client";
import i18n from "@/i18n";
import { moment } from "@/i18n/datum";

export type Inschrijfperiode = components["schemas"]["InschrijfperiodeDto"];

/**
 * `isOpen` is the server's, because that is the clock §4.1 is enforced on. Only which of the
 * catalog's sentences applies is worked out here.
 */
export function vensterStatus(periode: Inschrijfperiode | undefined) {
  if (!periode) {
    return {
      open: false,
      label: i18n.t("inschrijving:venster.geenPeriode"),
    } as const;
  }

  if (periode.isOpen) {
    return {
      open: true,
      label: i18n.t("inschrijving:venster.open", {
        moment: moment(periode.closesOn),
      }),
    } as const;
  }

  return new Date(periode.opensOn).getTime() > Date.now()
    ? ({
        open: false,
        label: i18n.t("inschrijving:venster.opent", {
          moment: moment(periode.opensOn),
        }),
      } as const)
    : ({
        open: false,
        label: i18n.t("inschrijving:venster.gesloten", {
          moment: moment(periode.closesOn),
        }),
      } as const);
}

/**
 * The first open window, otherwise the first there is. The fallback matters: no read is gated
 * (ADR-0031), so nothing would blank the screen just as a korps comes to check what they entered.
 */
export function huidigePeriode(periodes: Inschrijfperiode[] | undefined) {
  return periodes?.find((periode) => periode.isOpen) ?? periodes?.[0];
}

/** The first window that has not closed, by the server's clock: what a countdown runs towards. */
export function volgendePeriode(periodes: Inschrijfperiode[] | undefined) {
  return periodes?.find(
    (periode) => Date.parse(periode.closesOn) > Date.parse(periode.serverNow),
  );
}
